const home = {
  head: [
    {
      title: "Swap",
      url: "https://swap.transit.finance?locale=en",
    },
    {
      title: "NFT",
      list: [
        {
          title: "NFT Design Competition",
          // url: "https://tp-lab.tokenpocket.pro/mint-skin/index.html#/",
          url: "https://tp-lab.tokenpocket.pro/mint-skin-2/index.html#/",
          icon: require("../../assets/mobile/header/nft_design.png"),
        },
        {
          title: "Transit NFT",
          url: "https://nft.transit.finance/#/",
          icon: require("../../assets/mobile/header/transit_nft.png"),
        },
        {
          title: "NFT MarketPlace",
          url: "https://nft.transit.finance/waitlist/#/",
          icon: require("../../assets/pc/header/NFT_Marketplace.png"),
        },
      ],
    },
    {
      title: "Download TP",
      url: "https://tp.transit.finance/en/download/app",
    },
    {
      title: "Governance",
      list: [
        {
          title: "DAO",
          desc: "Stake TPT and get xTPT to participate in governance.",
          url: "/en/stake/",
          icon: require("../../assets/mobile/header/dao.png"),
          // soon: 'Soon',
          type: "route",
        },
        {
          title: "Donation",
          desc: "Non-profit donation to Transit Swap for better marketing and operation.",
          url: "/en/donation/",
          icon: require("../../assets/mobile/header/donate.png"),
          type: "route",
        },
        {
          title: "fee",
          desc: "Hold TPT or xTPT to get a special discount of trading fee.",
          url: "/en/fee/",
          icon: require("../../assets/mobile/header/donate.png"),
          type: "route",
        },
      ],
    },
    {
      title: "Community",
      list: [
        {
          title: "Transit Swap Forum",
          desc: "",
          url: "https://fans.tokenpocket.pro/c/xswap-announcement-xswap/14",
          icon: require("../../assets/mobile/header/community.png"),
        },
        {
          title: "Twitter",
          desc: "",
          url: "https://twitter.com/TransitFinance",
          icon: require("../../assets/mobile/header/twitter.png"),
        },
        {
          title: "Help Center",
          desc: "",
          url: "https://docs.transit.finance/en/",
          icon: require("../../assets/mobile/header/docs.png"),
        },
      ],
    },
    {
      title: "Buy Crypto",
      // url: 'https://www.transit.finance/openc/index.html?widgetId=UjcyR3hQVlk',
      url: "https://openc.pro/widget-page/?widgetId=UjcyR3hQVlk",
    },
  ],
  launchApp: "Launch App",
  introduction: {
    desc: "The brand new way you can experience decentralized exchanges, better liquidity and better return, all chains in one single Transit Swap",
    start: "Start Trading Now",
  },
  section1: {
    desc: "Transit Swap integrates the most popular DEXs of public chains, selects and combines their advantages intelligently to provide better depth for your transactions and return more target tokens. With Transit Swap, you don't need to worry about what DEX can be traded and what DEX has a better depth. Transit Swap is your preference for trading.",
    advantage: [
      {
        icon: require("../../assets/pc/section1/chains.png"),
        desc: "Save the trouble of choice through multi-chain transactions",
      },
      {
        icon: require("../../assets/pc/section1/polymerization.png"),
        desc: "Gather the advantages together, make the depth deeper, and make the price better.",
      },
      {
        icon: require("../../assets/pc/section1/bridge.png"),
        desc: "Make cross-chain transactions safer and easier",
      },
      {
        icon: require("../../assets/pc/section1/safe.png"),
        desc: "Approve once and use multiple to make transactions safer",
      },
    ],
  },
  section2: {
    desc: "Transit Swap selects transaction routes intelligently with a variety of strategies, offering the best transaction prices after comparing other prices.",
  },
  section3: {
    desc: "Your assets can be easily transferred between multiple chains by aggregating multiple cross-chain routes, so that cross-chains will no longer be your troubles.",
  },
  end: {
    start: "Start Trading Now",
  },
  foot: {
    info: [
      //     {
      //     title: 'Privacy policy',
      //     url: 'https://www.baidu.com',
      // },
      {
        title: "User Agreement",
        url: "https://tp-lab.tokenpocket.pro/TransitSwapUserAgreement/index.html?locale=en#/",
      },
    ],
    language: "简体中文",
    media: {
      mailUrl: "service@transit.finance",
      codeCatUrl: "https://github.com/transit-finance",
      twitterUrl: "https://twitter.com/TransitFinance",
      mUrl: "https://fans.tokenpocket.pro/c/xswap-announcement-xswap/14",
      tgUrl: "https://t.me/Transit_Finance",
    },
    copyright: "Transit Swap@2021, All Rights Reserved",
  },
  donation: {
    know: {
      title: "Transit Swap Donation Pool Definition:",
      desc: "As part of the open blockchain world, the Transit Swap project accepts Token donations from individual users, all donations will go into a donation pool, which will be used for purposes including but not limited to Transit Swap project operations and funding for the Transit Swap related ecosystem.",
    },
    tip: {
      title: "Important note:",
      desc:
        "The Transit Swap project does not offer definitive rewards to donors; donors who wish to return their donations within 72 hours of the donation hash may do so via the official contact form, but requests for return after this time limit will not be processed.\n" +
        "Types of donation tokens we accept: TPT\n",
    },
    donateType: {
      title: "Donations accepted address",
      desc: "TPT",
    },
    address: {
      title: "Donations accepted address:",
    },
    join: "Donate",
    donateChain: "Select a chain",
    connectWallet: "连接钱包",
    donateTip: {
      title: "Caution:",
      desc: "Transit Swap does not offer definitive rewards to donors; If you regret to donate, please send the transaction hash to official email within 72 hours to require return.",
    },
    warn: "Please select a chain first",
    transfer: "Please use TokenPokcet to scan this QR Code to donate TPT",
    copyAddress: "Copy address",
    copied: "Copied",
    yourAddress: "Your address",
    cantDonate: "The current chain does not support donations",
    confirmDonate: "Confirm donation",
    donateSuccess: "Success",
    donateFail: "Failed",
    overCount: "Insufficient balance",
    donateAddress: "Donation address",
    donateCount: "Donation Amount (TPT)",
    pleaseSwitch1: "Please switch to ",
    pleaseSwitch2: " network",
    downloadTP: "Cannot donate directly, please download TokenPocket",
    connectTronLink: "Please connect TronLink first",
    waitBlockConfirm: "Submitted",
    noZero: "The donation amount cannot be 0",
  },

  stake: {
    know: {
      title: "Stake TPT Get xTPT",
      desc: "Stake your TPT to get xTPT, which can be used to vote for the ecology improvement proposals. You can swap your xTPT back to TPT anytime you want.",
    },
    join: "Staked TPT",
    connectWallet: "Connect Wallet",
    networkNotvalid: "Please switch to BSC network",
    approve: "Approve",
    unstake: "Unstake",
    add: "Add",
    loginFirst: "-",
    deposit: "Deposit TPT",
    withdraw: "Withdraw TPT",
    balance: "Balance",
    confirm: "Confirm",
    overbalance: "Over available balance",
    success: "Success",
    all: "All",
    voteTip: "Use xTPT to vote for the propopals you support!",
    goVote: "Go to VOTE",
  },
  fee: {
    desc: "Transit Swap launches the aggregate transaction fee discount function, which according to the discount rate corresponding to the sum of the TPT and xTPT quantity held by the user's account address. There are currently 4 discount levels, and in the future, more levels will be split according to the actual situation.",
    feeDiscount: "Rate discount",
    walletBalance: "Balance",
    levelRank: "Level",
    levelBalance: "Balance (TPT and xTPT)",
    levelDiscountRate: "Discount Rate",
    level: [
      {
        rank: "LV.1",
        icon: require("../../assets/pc/fee/lv1.png"),
        balance: "≥10,000",
        discountRate: "10%",
      },
      {
        rank: "LV.2",
        icon: require("../../assets/pc/fee/lv2.png"),
        balance: "≥100,000",
        discountRate: "20%",
      },
      {
        rank: "LV.3",
        icon: require("../../assets/pc/fee/lv3.png"),
        balance: "≥1,000,000",
        discountRate: "40%",
      },
      {
        rank: "LV.4",
        icon: require("../../assets/pc/fee/lv4.png"),
        balance: "≥10,000,000",
        discountRate: "70%",
      },
    ],
  },
  warn: {
    content:
      'Rebranding Announcement: "<span class="bold">Xswap</span>" Is Officially Upgraded to New Brand Name - "<span class="bold">Transit Swap</span>"',
    url: "https://medium.com/@TransitSwap/xswap-announced-rebranding-brand-name-officially-upgraded-to-transit-swap-52c4c11672ec",
    text: "Learn more",
  },
  modal: {
    desc1: "Transit Staffs won't send you private messages!",
    desc2:
      "Caution! You're entering Transit community, there might be someone impersonating us to send you private messages! Please be aware that, anyone who sends private messages might be a scammer! We will never contact you first!",
    desc3: "Understood, enter",
  },
};
export default home;
